import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { ContentSizeService } from '../services/content-size/content-size.service';
import { ReplaySubject, Subject, interval } from 'rxjs';
import { ElementSize } from './element-size';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[pcpSizeMonitor]',
    standalone: true
})
export class SizeMonitorDirective implements OnDestroy {
  constructor(service: ContentSizeService, el: ElementRef) {
    interval(1000)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        const rect = (el.nativeElement as HTMLElement).getBoundingClientRect();
        let change = false;
        if (this.width !== rect.width) {
          change = true;
          this.width = rect.width;
        }
        if (this.height !== rect.height) {
          change = true;
          this.height = rect.height;
        }
        if (change && this.width && this.height) {
          (service.contentSize$ as ReplaySubject<ElementSize>).next(
            new ElementSize(this.width, this.height)
          );
        }
      });
  }
  private width: number | null = null;
  private height: number | null = null;
  private onDestroy$ = new Subject<void>();

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
